import { render, staticRenderFns } from "./ProgramFormField.vue?vue&type=template&id=63089c46&"
import script from "./ProgramFormField.vue?vue&type=script&lang=js&"
export * from "./ProgramFormField.vue?vue&type=script&lang=js&"
import style0 from "./ProgramFormField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports